jQuery(document).ready(function($) {
  $('.a-hamburger').click(function() {
    $(this).toggleClass('a-hamburger--toggled');
  });

});